const FailureScreen = ({ message }) => (
  <div className="bg-white shadow-md p-6 rounded-2xl border text-center">
    <div className="text-red-600 text-5xl mb-3">✖</div>

    <h2 className="text-xl font-semibold text-red-600 mb-1">
      Transfer Failed
    </h2>

    <p className="text-gray-600 mt-2">{message}</p>
  </div>
);

export default FailureScreen;